

document.addEventListener('DOMContentLoaded', function () {
  let lastText = null;

  setInterval(function () {
    const button = document.querySelector('.product-form__buttons .button-text');
    const container = document.querySelector('.product__info-container');

    if (!button || !container) return;

    const currentText = button.getAttribute('data-text')?.trim();

    if (currentText !== lastText) {
      console.log('[custom.js] data-text changed:', currentText);

      if (currentText === 'Pre-Order') {
        container.classList.add('has-preorder');
      } else {
        container.classList.remove('has-preorder');
      }

      lastText = currentText;
    }
  }, 200); // Check every 200ms
});



$(document).ready(function () {

  document.addEventListener('DOMContentLoaded', function () {
  const buttonTextEl = document.querySelector('.product-form__buttons .button-text');

  if (!buttonTextEl) return;

  function updatePreOrderClass() {
    const text = buttonTextEl.getAttribute('data-text')?.trim();
    const infoContainer = document.querySelector('.product__info-container');

    if (!infoContainer) return;

    if (text === 'Pre-Order') {
      infoContainer.classList.add('has-preorder');
    } else {
      infoContainer.classList.remove('has-preorder');
    }

    console.log('[custom.js] data-text is now:', text);
  }

  // Observe attribute & child changes on .button-text
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' ||
        mutation.type === 'characterData' ||
        mutation.type === 'childList'
      ) {
        updatePreOrderClass();
      }
    }
  });

  observer.observe(buttonTextEl, {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true,
  });

  // Also check once on load
  updatePreOrderClass();
});
  

  // ------------------------- Header
  var header_group_offset = 10;
  // console.log(header_group_offset)
  $(window).scroll(function () {
    const scrollTop = $(this).scrollTop();
    if (scrollTop > header_group_offset){
      $('#header-group-wrap').addClass('header-group-sticky');
    }else{
      $('#header-group-wrap').removeClass('header-group-sticky');
    }
  });
  
  $(window).scroll();

  if($('#announcement__bar').length > 0){
    var header_announcement_speed = $('#announcement__bar').data('desktop-speed');
    if ($(window).width() < 750) {
      header_announcement_speed = $('#announcement__bar').data('mobile-speed');
    }
    $('#announcement__bar .marquee').marquee({
      gap: 0,
      speed: header_announcement_speed*1000,
      delayBeforeStart: 1000,
      direction: 'left',
      duplicated: true
    });
  }

  var header_sticky_tranform = $('#announcement__bar').length > 0 ? $('#announcement__bar').outerHeight() : 0;
  $('html').css('--header-sticky-tranform', header_sticky_tranform + 'px');

  $('#menu-drawer--close').click(function (e) {
    e.preventDefault();
    $('#Details-menu-drawer-container .header__icon--summary').click();
    setTimeout(function () {
      $('.menu-drawer-dropdown-toggle').removeClass('active').next('.menu-drawer-dropdown').removeClass('fade').slideUp();
      $('.has_sumenu_drawer').removeClass('submenu_active');
      $('.menu-drawer__navigation').removeClass('submenu_open');
    },500);
  });
  
  $('#menu-drawer--search').click(function (e) {
    e.preventDefault();
    $('#Details-menu-drawer-container .header__icon--summary').click();
    setTimeout(function(){$('.main-header__icons .header__search .header__icon--search').click()},400);
  });

  $('#menu-drawer--cart').click(function (e) {
    e.preventDefault();
    $('#Details-menu-drawer-container .header__icon--summary').click();
    $('.main-header__icons #cart-icon-bubble').click();
  });

  if($('.menu-drawer-dropdown-toggle').length > 0){
    $('.menu-drawer-dropdown-toggle').click(function (e) {
      e.preventDefault();
      var toggle = $(this);
      toggle.toggleClass('active');
      toggle.next('.menu-drawer-dropdown').slideToggle();
      if(toggle.hasClass('active')){
        setTimeout(function () {
          toggle.next('.menu-drawer-dropdown').addClass('fade');
        },200);
      }else{
        toggle.next('.menu-drawer-dropdown').removeClass('fade');
      }
    });
  }

  if($('.has_sumenu_drawer').length > 0){
    $('.sumenu_drawer-toggle,.menu-drawer__submenu-close').click(function (e) {
      e.preventDefault();
      $(this).parents('.has_sumenu_drawer').toggleClass('submenu_active');
      $(this).parents('.menu-drawer__navigation').toggleClass('submenu_open');
    });
  }

  $('.header__search .search-modal__button,.header__search .search-modal__close-button,.header__search .modal-overlay').click(function (e) {
    e.preventDefault();
    $(this).parents('.header__search').find('.search-modal').fadeToggle();
    $('#header-group-wrap').toggleClass('search-open');
  })
  
  // ------------------------- Header

  // ------------------------- Video Banner Play pause
  if($('.banner-video-text').length > 0){
    $('.banner-video-text [data-banner-video]').click(function () {
      if($(this).hasClass('play-video')){
        $(this).removeClass('play-video');
        $(this).find('video')[0].pause();
        if($(this).find('video.small-up-hide').length > 0){
          $(this).find('video.small-up-hide')[0].pause();
        }
      }else{
        $(this).addClass('play-video');
        $(this).find('video')[0].currentTime = 0;
        $(this).find('video')[0].play();
        if($(this).find('video.small-up-hide').length > 0){
          $(this).find('video.small-up-hide')[0].currentTime = 0;
          $(this).find('video.small-up-hide')[0].play();
        }
      }
    });
  }
  // ------------------------- Video Banner Play pause


  // ------------------------- Language Currency Popup
  $('[data-target-currency-popup]').click(function(e) {
    e.preventDefault();
    $('[data-currency-popup]').addClass('open-popup');
    $('body').addClass('overflow-hidden');
  });
  $('[data-target-language-popup]').click(function(e) {
    e.preventDefault();
    $('[data-language-popup]').addClass('open-popup');
    $('body').addClass('overflow-hidden');
  });
  $('.language-currency-popup .language-currency-popup-overlay,.language-currency-popup .language-currency-popup-close').click(function (e) {
    e.preventDefault();
    $('.language-currency-popup').removeClass('open-popup');
    $('body').removeClass('overflow-hidden');
  });
  // ------------------------- Language Currency Popup

  // -------------------------  Product Card Media
  if($('.product-card-wrapper').length > 0){
    $('.product-card-wrapper').each(function () {
      var product_card_media_slider = new Swiper($(this).find('.product-card-media-slider')[0],{
        slidesPerView: 1,
        spaceBetween: 7,
        initialSlide: $(this).find('.product-card-media-img.active').index(),
        loop: true,
        allowTouchMove: false,
        navigation: {
          nextEl: $(this).find('.product-card-media-slider .swiper-button-next')[0],
          prevEl: $(this).find('.product-card-media-slider .swiper-button-prev')[0],
        },
        pagination: {
          el: $(this).find('.product-card-media-slider .swiper-pagination')[0],
    	  clickable: true,
        },
        nested: true
      });
    });
  }
  // -------------------------  Product Card Media

  // -------------------------  Contact Form
  if($('.contact-page .form_success_close').length > 0){
    $('.contact-page .form_success_close').click(function (e) {
      e.preventDefault();
      $(this).parents('.form__wrap').removeClass('form_successfully_submit');
    });
  }
  // -------------------------  Contact Form


  // -------------------------  Size Guide
  if($('.size-guide').length > 0){
    $('.size-guide .size-guide-block-footer .size-unit-toggle').click(function (e) {
      e.preventDefault();
      var unit = $(this).data('class');
      $(this).addClass('active').siblings().removeClass('active');
      $(this).parents('.size-guide-block').find('.size-guide-table').attr('data-unit',unit);
    });
  }
  // -------------------------  Size Guide


  // -------------------------  Faq Block
  $('body').on('click', '[data-faq-block] [data-faq-toggle]', function(e) {
    e.preventDefault();
    $(this).next('[data-faq-content]').slideToggle().parents('[data-faq-block]').toggleClass('active');
  });
  // -------------------------  Faq Block


  // ------------------------- Collection 
  if ($('.template-collection .action-for-product-grid .toggle-action-btn').length > 0) {
    $('body').on('click', '.template-collection .action-for-product-grid .toggle-action-btn', function (e) {
      e.preventDefault();
      var value = $(this).data('class');
      $(this).addClass('active').siblings().removeClass('active');
      if ($(this).is('[data-img-change]')) {
        var show_img = $(this).data('img-change');
        $(this).parents('#collection-main-wrap').attr('data-product-img', show_img);
        
        if (show_img == 'model') {
          $('.product-card-wrapper').each(function () {
            var currentColor = $(this).find('[data-color="yes"] .product-card-color.current').attr('data-value') || $(this).find('[data-color="yes"] .product-card-color.default').attr('data-value');
            if ($(this).find('.card__media .product-card-media-img[data-model-alt="'+currentColor+' - Model"]').length) {
              var slideIndex = $(this).find('.card__media .product-card-media-img[data-model-alt="'+currentColor+' - Model"]').index();
              $(this).find('.product-card-media-slider')[0].swiper.slideTo(slideIndex, 0);
            } else if ($(this).find('.card__media .product-card-media-img[data-model-alt="Model"]').length) {
              var slideIndex = $(this).find('.card__media .product-card-media-img[data-model-alt="Model"]').index();
              $(this).find('.product-card-media-slider')[0].swiper.slideTo(slideIndex, 0);
            }
          });
        } else {
          $('.product-card-wrapper').each(function () {
            var currentId = $(this).find('.card__media').attr('data-current-image-id');
            if ($(this).find('.card__media .product-card-media-img[data-image-id="'+currentId+'"]').length) {
              var slideIndex = $(this).find('.card__media .product-card-media-img[data-image-id="'+currentId+'"]').index();
              $(this).find('.product-card-media-slider')[0].swiper.slideTo(slideIndex, 0);
            } else {
              if ($(this).find('.card__media .product-card-media-img.active').length) {
                var slideIndex = $(this).find('.card__media .product-card-media-img.active').index();
              } else {
                var slideIndex = 0;
              }
              $(this).find('.product-card-media-slider')[0].swiper.slideTo(slideIndex, 0);
            }
          });
        }
        
      } else if ($(this).is('[data-grid]')) {
        var grid = $(this).data('grid');
        $(this).parents('#collection-main-wrap').attr('data-grid', grid);
      }
    });
  }
  // ------------------------- Collection

  // ------------------------- Facet
  if($('.facets-wrapper').length > 0){

    let height = $("#FacetFiltersFormMobile").css({ visibility: "hidden", display: "block" }).outerHeight();
    $("#FacetFiltersFormMobile").css({ visibility: "visible", display: "none" }); // Hide again
    
    $('body').on('click', '.mobile-facets__toggle', function (e) {
      e.preventDefault();
      var toggle = $(this);
      $(this).toggleClass('active');
      $('#FacetFiltersFormMobile').slideToggle();
      if(toggle.hasClass('active')){
        setTimeout(function () {
          $('#FacetFiltersFormMobile').addClass('fade');
        },200);
        $('#main-collection-filters').animate({ 'margin-bottom': height + 'px'});
      }else{
        $('#FacetFiltersFormMobile').removeClass('fade');
        $('#main-collection-filters').animate({ 'margin-bottom': 0 + 'px'});
      }
    });

    let sort_height = $(".sort_by-filter-main").css({ visibility: "hidden", display: "block" }).outerHeight();
    $(".sort_by-filter-main").css({ visibility: "visible", display: "none" }); // Hide again
    
    $('body').on('click', '.sort_by-filter-toggle', function (e) {
      e.preventDefault();
      var toggle = $(this);
      toggle.toggleClass('active');
      $(this).next('.sort_by-filter-main').slideToggle();
      if(toggle.hasClass('active')){
        setTimeout(function () {
          toggle.next('.sort_by-filter-main').addClass('fade');
        },200);
        $('#ProductGridContainer').animate({ 'margin-top': sort_height + 'px'});
      }else{
        toggle.next('.sort_by-filter-main').removeClass('fade');
        $('#ProductGridContainer').animate({ 'margin-top': 0 + 'px'});
      }
    });

    $('body').on('click', '.sort_by-filter-main input[name="sort_by"]', function (e) {
      setTimeout(function () {
        $('#ProductGridContainer').animate({ 'margin-top': 0 + 'px'});
      },2000);  
    });

    $('body').on('click',function(event){
      if(!$(event.target).is('#FacetSortDrawerForm *')){
        $('.sort_by-filter-toggle').removeClass('active');
        $('#FacetSortDrawerForm .sort_by-filter-main').slideUp().removeClass('fade');
        $('#ProductGridContainer').animate({ 'margin-top': 0 + 'px'});
      }

      if(!$(event.target).is('.mobile-facets__wrapper *')){
         $('.mobile-facets__toggle').removeClass('active');
         $('#FacetFiltersFormMobile').slideUp().removeClass('fade');
         $('#main-collection-filters').animate({ 'margin-bottom': 0 + 'px'});
       }
    });
    
    var filter_bar_height = $('.facets-wrapper').innerHeight();
    var filter_bar_viewport_pos = $('.facets-wrapper')[0].getBoundingClientRect().top;
    $('.facets-wrapper').css('--filter-height-offset', filter_bar_height + filter_bar_viewport_pos +'px');
    $(window).on('scroll',function () {
      filter_bar_viewport_pos = $('.facets-wrapper')[0].getBoundingClientRect().top;
      if(filter_bar_viewport_pos > 30){
        $('.facets-wrapper').css('--filter-height-offset', filter_bar_height + filter_bar_viewport_pos+'px');
      }
    });
  }
  // ------------------------- Facet

  // ------------------------- Product
  if($('#product__media-list').length > 0){
    var main_product_card_media_slider = new Swiper('#product__media-list' ,{
      slidesPerView: 1,
      spaceBetween: 7,
      initialSlide: $('#product__media-list').find('.product__media-item.active').length ? $('#product__media-list').find('.product__media-item.active').index() : 0,
      loop: true,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: '#product__media-list .swiper-button-next',
        prevEl: '#product__media-list .swiper-button-prev',
      }
    });
  }
  // ------------------------- Product


  // ------------------------- Cart drawer also like slider
  if ($('#cart-drawer-also-like-slider').length > 0) {
    $('#cart-drawer-also-like').show();
    var cart_drawer_also_like = new Swiper('#cart-drawer-also-like #cart-drawer-also-like-slider',{
      slidesPerView: 'auto',
      spaceBetween: 6,
      loop: true,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: '#cart-drawer-also-like .swiper-action-bar .swiper-button-next',
        prevEl: '#cart-drawer-also-like .swiper-action-bar .swiper-button-prev',
      }
    });
    $('#cart-drawer-also-like-slider .product-card-wrapper').each(function () {
      var product_card_media_slider = new Swiper($(this).find('.product-card-media-slider')[0],{
        slidesPerView: 1,
        spaceBetween: 7,
        initialSlide: $(this).find('.product-card-media-img.active').length ? $(this).find('.product-card-media-img.active').index() : 0,
        loop: true,
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: $(this).find('.product-card-media-slider .swiper-button-next')[0],
          prevEl: $(this).find('.product-card-media-slider .swiper-button-prev')[0],
        },
        nested: true
      });
    });
  }
  // ------------------------- Cart drawer also like slider

  // ------------------------- Shop Cart
  if($('#shop-cart').length > 0){
    $(document).on('click','#shop-cart-heading',function () {
      $(this).parents('#shop-cart').toggleClass('open-shop-cart');
    });
  }
  // ------------------------- Shop Cart

  // ------------------------- Capsule Featured Product
  if($('.capsule-featured-product').length > 0){

    var capsule_featured_product_thumb = new Swiper('#capsule-featured-product-thumb' ,{
      slidesPerView: 'auto',
      freeMode: true,
      spaceBetween: 5,
      mousewheel: {
        forceToAxis: true
      },
      direction: 'vertical',
      breakpoints: {
        990: {
          spaceBetween: 10,
        },
      }
    });

    var capsule_featured_product_slider = new Swiper('.capsule-card #capsule-card-images' ,{
      slidesPerView: 1,
      spaceBetween: 5,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: '#capsule-card-images .swiper-button-next',
        prevEl: '#capsule-card-images .swiper-button-prev',
      },
      breakpoints: {
        990: {
          spaceBetween: 10,
        },
      }
    });    
    
    $('.capsule-featured-product-view-mode .toggle-action-btn').click(function (e) {
      e.preventDefault();
      var value = $(this).data('class');
      $(this).addClass('active').siblings().removeClass('active');
      $(this).parents('.capsule-featured-product-row').attr('data-grid', value);
    })
  }
  // ------------------------- Capsule Featured Product

  // ------------------------- tip popup
  if($('#tip-popup').length > 0){
    setTimeout(function () {
      $('#tip-popup').fadeIn();
    },5000);
    
    $('#tip-popup-close').click(function (e) {
      e.preventDefault();
      $(this).parents('#tip-popup').fadeOut();
    })
  }
  // ------------------------- tip popup

  // ------------------------- Quick View
  if($('#quick-view').length > 0){
    $('body').on('click', '[data-quickview]', function(e) {
      e.preventDefault();
      var handle = $(this).attr('data-handle');
      var c_v = $(this).parents('.card-shop-product').find('[name="id"]').val();
      $.get('/products/'+handle+'?variant='+c_v+'&view=quick-view', function(data) {
        $('[data-quickview-content]').html($(data).find('.quick_view_section').html());
        var capsule_featured_product_slider = new Swiper('#quick-view-media-slider' ,{
          slidesPerView: 1,
          spaceBetween: 10,
          initialSlide: $('#quick-view-media-slider').find('.quick-media-image.active').length ? $('#quick-view-media-slider').find('.quick-media-image.active').index() : 0,
          loop: true,
          mousewheel: {
            forceToAxis: true
          },
          navigation: {
            nextEl: '#quick-view-media-slider .swiper-button-next',
            prevEl: '#quick-view-media-slider .swiper-button-prev',
          }
        });
        $('body').addClass('overflow-hidden');
        $('#quick-view').fadeIn();
      });
    });

    $('body').on('click', '#quick-view-close, #quick-view-overlay', function(e) {
      e.preventDefault();
      $(this).parents('#quick-view').fadeOut();
      $('body').removeClass('overflow-hidden');
    });
  }
  // ------------------------- Quick View

  /*
  // ------------------------- Wishlist AddToCart
  // Define eventname
  let event = 'sw:addedtocart';
  
  // Define the event listener function
  let listener = function(e) { 
    var data = e.detail.d.productData;	
    console.log("YAY! Added the product to cart", data);
    // update button state here...
  };
  
  // Add listener for the 'addedtocart' event to the Swym Event Layer
  swat.evtLayer.addEventListener(event, listener);
  */
  
});


// Style Guides Filtering
$(document).ready(function () {
  let selectedFilters = [];
  filterStyleGuides();

  $(".filter-item").on("click", function () {
    const value = $(this).data("value").toLowerCase().trim().replace(/\s+/g, "-");

    // Toggle selection
    if ($(this).hasClass("selected")) {
      $(this).removeClass("selected");
      selectedFilters = selectedFilters.filter(tag => tag !== value);
    } else {
      $(this).addClass("selected");
      selectedFilters.push(value);
    }

    updateSelectedFilters();
    filterStyleGuides();
  });

  function updateSelectedFilters() {
    let selectedTagsContainer = $(".selected-tags");
    selectedTagsContainer.empty(); // Clear before updating

    selectedFilters.forEach(filter => {
      let tagElement = $(`<span class="filter-tag">${filter.replace(/-/g, " ")} <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.19434 1L0.999965 7.99993" stroke="black" stroke-width="0.77379"/>
<path d="M8.19434 8L0.999965 1.00007" stroke="black" stroke-width="0.77379"/>
</svg>
</span>`);
      tagElement.attr("data-value", filter);
      
      // Allow tag removal when clicked
      tagElement.on("click", function () {
        removeFilter(filter);
      });

      selectedTagsContainer.append(tagElement);
    });
  }

  function removeFilter(filterValue) {
    selectedFilters = selectedFilters.filter(tag => tag !== filterValue);

    $(".filter-item").each(function () {
      if ($(this).data("value").toLowerCase().trim().replace(/\s+/g, "-") === filterValue) {
        $(this).removeClass("selected");
      }
    });

    updateSelectedFilters();
    filterStyleGuides();
  }

  function filterStyleGuides() {
    let visibleCount = 0;

    $(".style-guide-item").each(function () {
      let itemTags = $(this).data("tags").split(",");

      // If no filters are selected, show all items
      if (selectedFilters.length === 0) {
        $(this).fadeIn();
        visibleCount++;
        return;
      }

      // Show items that match at least one selected filter
      let showItem = selectedFilters.some(filter => itemTags.includes(filter));

      if (showItem) {
        $(this).fadeIn();
        visibleCount++;
      } else {
        $(this).fadeOut();
      }
    });

    // Update results count text
    $(".results-count").text(visibleCount + " Style Guides Found");
  }
});

$(document).ready(function () {
  function updateFilterHeaderClass() {
    if ($(".selected-tags").children().length > 0) {
      $(".filter-header").addClass("tag-selected");
    } else {
      $(".filter-header").removeClass("tag-selected");
    }
  }

  // Run function on load to check if any tags are already selected
  updateFilterHeaderClass();

  // Create a MutationObserver to watch for changes in `.selected-tags`
  const observer = new MutationObserver(updateFilterHeaderClass);
  observer.observe(document.querySelector(".selected-tags"), { childList: true });
});

$(document).ready(function () {
  $(".filter-title").on("click", function () {
    let filterGroups = $(".filter-groups");

    if (filterGroups.hasClass("open")) {
      // Close the filter
      filterGroups.stop().animate({ height: "0px" }, 300, function () {
        $(this).removeClass("open").css({ display: "none", height: "" }); // Hide properly
      });

      // Swap icons (minus → plus)
      $(".icon-minus").hide();
      $(".icon-plus").css("display", "flex"); // Ensure plus icon uses flex
    } else {
      // Open the filter
      filterGroups
        .css({ display: "flex", height: "0px", overflow: "hidden" }) // Ensure flex display before animation
        .stop()
        .animate({ height: filterGroups.get(0).scrollHeight + "px" }, 300, function () {
          $(this).addClass("open").css("height", "auto"); // Set to auto after animation
        });

      // Swap icons (plus → minus)
      $(".icon-plus").hide();
      $(".icon-minus").css("display", "flex"); // Ensure minus icon uses flex
    }
  });
});

$(document).ready(function () {
  document.addEventListener("DOMContentLoaded", function() {
    // Select all anchor tags with an href attribute
    const links = document.querySelectorAll('a[href]');
    
    links.forEach(link => {
      // Check if the link is external by comparing hostnames
      if (link.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        // Adding rel attribute for security reasons
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  });
});


$('.build-capsule-action-row').on('click', function() {
  $('.build-capsule-action-row').removeClass('selected');
  $(this).addClass('selected');
});